import logo from '../logo.svg';
import '../App.css';
import Appbar from '../component/appbar';
import Foot from '../component/foot';

function Home() {
  return (
    <div className="App">
    <Appbar />
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
      <Foot />
    </div>
  );
}

export default Home;
